// extracted by mini-css-extract-plugin
export default {"buttons":"show_buttons__v80qX","table":"show_table__wqPAt"};